module.exports = __webpack_public_path__ + "static/media/circlemain.18361a3c.svg";